import { Injectable } from '@angular/core';
import { HttpService } from '@sdbn/appclient';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ServiceResponse } from '@sdbn/appclient';
import { DataProtectionRule, DataProtectionRuleDetails } from './data-protection-rules-model';

@Injectable({
  providedIn: 'root'
})
export class DataProtectionRulesService {

  constructor(private tmcHttpService: HttpService) { }

  getRules(): Observable<DataProtectionRule[]> {
    return this.tmcHttpService.postWithContext<DataProtectionRule[]>(environment.dataProtectionAdminEndpoint, {});
  }

  getDetails(ruleId: number): Observable<DataProtectionRuleDetails> {
    return this.tmcHttpService.postWithContext<DataProtectionRuleDetails>(environment.dataProtectionAdminEndpoint + '/details', ruleId);
  }

  saveDetails(smartphone: DataProtectionRuleDetails): Observable<ServiceResponse> {
    return this.tmcHttpService.postWithContext<ServiceResponse>(environment.dataProtectionAdminEndpoint + '/save', smartphone);
  }

  deleteRule(ruleId: number): Observable<ServiceResponse> {
    return this.tmcHttpService.postWithContext<ServiceResponse>(environment.dataProtectionAdminEndpoint + '/delete', ruleId);
  }
}
